module.exports = __webpack_public_path__ + "img/registerlogin_2.13d201d9.jpg";